import Vue from "vue";
import Vuex from "vuex";
import { axiosBase } from "../api/axios-base";
import LogRocket from "logrocket";
import createPlugin from "logrocket-vuex";

const canonicalLoginPath = "/app/auth/login";

const logrocketPlugin = createPlugin(LogRocket);

import * as modules from "./modules/modules";
import * as lesson from "./modules/lesson";
import * as admin from "./modules/admin";
import * as progress from "./modules/progress";
import * as cloud from "./modules/cloud";

Vue.use(Vuex);
export default new Vuex.Store({
  state: {
    profile: JSON.parse(localStorage.getItem("profile")) || null,
    student: JSON.parse(localStorage.getItem("student")) || null,
    studentDialog: false,
    snackShow: false,
    snackSuccess: false,
    snackVersion: false,
    snackbar: {},
    next: null,
    isAuthenticated: false,
  },
  getters: {
    loggedIn(state) {
      return state.isAuthenticated && state.profile != null;
    },
    profile: (state) => state.profile,
    student: (state) => state.student,
    studentDialog: (state) => state.studentDialog,
    snackShow: (state) => state.snackShow,
    snackbar: (state) => state.snackbar,
    snackSuccess: (state) => state.snackSuccess,
    snackVersion: (state) => state.snackVersion,
    next: (state) => state.next,
  },
  mutations: {
    setAuthenticated(state, value) {
      state.isAuthenticated = value;
    },
    logout(state) {
      state.isAuthenticated = false;
      state.profile = null;
      state.student = null;
      localStorage.removeItem("profile");
      localStorage.removeItem("student");
    },
    updateProfile(state, profile) {
      state.profile = Object.assign(state.profile || {}, profile);
      let item = localStorage.getItem("profile");
      item = Object.assign(JSON.parse(item) || {}, profile);
      localStorage.setItem("profile", JSON.stringify(item));
    },
    updateStudent(state, student) {
      state.student = student;
      localStorage.setItem("student", JSON.stringify(student));
    },
    updateSnackbar(state, payload) {
      state.snackbar = payload;
      state.snackShow = true;
      state.snackSuccess = false;
    },
    snackShow(state, payload) {
      state.snackShow = payload;
      state.snackSuccess = false;
    },
    snackSuccess(state, payload) {
      state.snackSuccess = payload;
    },
    snackVersion(state, payload) {
      state.snackVersion = payload;
    },
    next(state, payload) {
      state.next = payload;
    },
    studentDialog(state, payload) {
      state.studentDialog = payload;
    },
  },
  actions: {
    async logoutUser(context) {
      if (context.getters.loggedIn) {
        try {
          await axiosBase.post("/api/myprofile/logout/");
          // eslint-disable-next-line no-empty
        } catch {}
        context.commit("logout");
        window.location.assign(canonicalLoginPath);
      }
    },
    async loginUser(context, credentials) {
      try {
        await axiosBase.post("/api/auth/obtain-token/", {
          email: credentials.email,
          password: credentials.password,
        });
        await context.dispatch("getProfile");
      } catch (error) {
        throw error;
      }
    },
    async getProfile(context) {
      try {
        const response = await axiosBase.get("/api/myprofile/");
        if (response.status === 200 && response.data) {
          context.commit("updateProfile", response.data);
          context.commit("setAuthenticated", true);
          return true;
        }
        context.commit("setAuthenticated", false);
        return false;
      } catch (error) {
        context.commit("setAuthenticated", false);
        return false;
      }
    },
  },
  modules: {
    modules,
    lesson,
    admin,
    progress,
    cloud,
  },
  plugins: [logrocketPlugin],
});
